export default {
    computed: {
        isAnimalFacility() { return this.currentModel.settings.isAnimalFacility; },
        isEzyvetFacility() { return this.currentModel.settings.isEzyvetFacility; },
        isOnline() { return this.$store.state.isOnline; },
        currentDemographic() { return this.$store.state.currentDemographic; },
        currentPetDemographic() { return this.$store.state.currentPetDemographic; },
        currentChiefComplaint() {  return this.$store.state.currentChiefComplaint; },
        currentContactInfo() { return this.$store.state.currentContactInfo; },
        currentOwnerContactInfo() { return this.$store.state.currentOwnerContactInfo; },
        currentCustomQuestions() { return this.$store.state.currentCustomQuestions; },
        currentClientDepartments() { return this.$store.state.currentClientDepartments; },
        ezyvetSteps() {
            return ['Owner Contact Info', 'Owner Info', 'Pet Info', 'Submit']
        },
        secondStep() {
            if (this.isEzyvetFacility) return 'ezyvetOwnerInfo';
            if (this.isAnimalFacility) return 'patientDemographics';

            if (this.currentModel.settings.showChiefComplaint)
                return 'chiefComplaint';
            if (this.currentModel.settings.showDepartmentList
                && this.currentModel.settings.clientDepartments
                && this.currentModel.settings.clientDepartments.length)
                return 'clientDepartments';
            if (this.currentModel.settings.customQuestions && this.currentModel.settings.customQuestions.length)
                return 'customQuestions';
            return false;
        },
        thirdStep() {
            if (this.isEzyvetFacility) return 'ezyvetPetInfo';
            if (this.isAnimalFacility) {
                if (this.currentModel.settings.showChiefComplaint)
                    return 'chiefComplaint';
                if (this.currentModel.settings.showDepartmentList
                    && this.currentModel.settings.clientDepartments
                    && this.currentModel.settings.clientDepartments.length)
                    return 'clientDepartments';
                if (this.currentModel.settings.customQuestions && this.currentModel.settings.customQuestions.length)
                    return 'customQuestions';
                return false;
            }

            if (!this.secondStep)
                return false;
            if ((this.secondStep === 'chiefComplaint'
                    || this.secondStep === 'clientDepartments')
                && this.currentModel.settings.customQuestions
                && this.currentModel.settings.customQuestions.length > 0)
                return 'customQuestions';
            return false;
        },
        fourthStep() {
            if (this.isEzyvetFacility) {
                if (this.currentModel.settings.customQuestions && this.currentModel.settings.customQuestions.length > 0) {
                    return 'customQuestions';
                }
                return false;
            }
            if (!this.thirdStep)
                return false;
            if ((this.thirdStep === 'chiefComplaint'
                || this.thirdStep === 'clientDepartments')
                && this.currentModel.settings.customQuestions
                && this.currentModel.settings.customQuestions.length > 0)
                return 'customQuestions';
            return false;
        },
        lastStep() {
            if (this.isEzyvetFacility) {
                if (this.isOnline)
                    return 1;

                return this.currentModel.settings.customQuestions
                    && this.currentModel.settings.customQuestions.length > 0
                    ? 5 : 4;
            }
            if (this.isOnline)
                return 1;
            if (this.secondStep && this.thirdStep && this.fourthStep) // if all steps active, what if for vet?
                return 5;
            if (this.isAnimalFacility) {
                if (this.thirdStep && this.fourthStep)
                    return 5;
                if (this.thirdStep || this.fourthStep)
                    return 4;
                return 3;
            }
            if (this.secondStep && this.thirdStep)
                return 4;
            if (this.secondStep || this.thirdStep)
                return 3;
            return 2;
        },
        showVisitType() {
            return this.currentModel
                && this.currentModel.settings.showDepartmentList
                && this.currentModel.settings.clientDepartments 
                && this.currentModel.settings.clientDepartments.length;
        },
        showChiefComplaint() {
            return this.currentModel.settings.showChiefComplaint;
        }
    },
    methods: {
        prevStep() {
            if (this.$store.state.onlineMultipleBookings) {
                this.$store.state.onlineMultipleBookings = false;
                return;
            }
            if (this.currentStep === 1) {
                this.$store.state.showGlassbreak = true;
            } else {
                this.$store.state.currentStep -= 1;
            }
        },
        nextStep() {
            if (this.isEzyvetFacility) {
                if (this.currentStep === 1) {
                    this.$store.state.currentStep += 1;
                } else if (this.currentStep === 2) {
                    this.$store.state.currentStep += 1;
                } else if (this.currentStep === 3) {
                    this.$store.state.currentStep += 1;
                } else if (this.currentStep === 4 && this.customQuestionsIsValid) {
                    this.$store.state.currentStep += 1;
                }
            }
            else {
                if (this.currentStep === 1 && this.demographicFormIsValid)
                    this.$store.state.currentStep += 1;
                else if (this.secondStep === 'patientDemographics' && this.petDemographicIsValid)
                    this.$store.state.currentStep += 1;
                else if (this.secondStep === 'patientDemographics' && this.petDemographicIsValid)
                    this.$store.state.currentStep += 1;
                else if (this.secondStep && (this.secondStep === 'chiefComplaint' || this.secondStep === 'clientDepartments') && this.chiefComplaintIsValid)
                    this.$store.state.currentStep += 1;
                else if (this.secondStep && this.secondStep === 'customQuestions' && this.customQuestionsIsValid)
                    this.$store.state.currentStep += 1;
                else if (this.thirdStep && this.thirdStep === 'customQuestions' && this.customQuestionsIsValid)
                    this.$store.state.currentStep += 1;
                else if (this.fourthStep && this.thirdStep === 'customQuestions' && this.customQuestionsIsValid)
                    this.$store.state.currentStep += 1;
            }
        }
    }
}